import {
  collection,
  limit,
  onSnapshot,
  orderBy,
  query,
  type Firestore,
} from 'firebase/firestore';

export interface IaHistoryEvent {
  id: string;
  at: Date | null;
  uid: string;
  email: string | null;
  source: 'mcp' | 'lia' | 'automatisation';
  action: 'create' | 'update' | 'archive' | 'restore' | 'delete';
  fields: string[];
}

/** Les anciennes traces restent lisibles apres unification des origines et des gestes. */
export function iaHistorySource(value: unknown): IaHistoryEvent['source'] {
  if (value === 'lia' || value === 'ask' || value === 'whatsapp') return 'lia';
  if (value === 'automatisation' || value === 'automation') return 'automatisation';
  return 'mcp';
}
export function iaHistoryAction(value: unknown): IaHistoryEvent['action'] {
  if (value === 'create' || value === 'archive' || value === 'restore' || value === 'delete') return value;
  return 'update';
}

export interface IaHistoryRepository {
  observe(family: string, recordId: string, onValue: (events: IaHistoryEvent[]) => void,
    onError?: (error: unknown) => void): () => void;
}

/** La sous-collection de la fiche reste sous ses droits de lecture. */
export function createIaHistoryRepository(db: Firestore): IaHistoryRepository {
  return {
    observe(family, recordId, onValue, onError) {
      if (!/^[A-Za-z][A-Za-z0-9]*$/.test(family) || !/^[A-Za-z0-9_-]{1,128}$/.test(recordId)) {
        throw new Error('Historique IA : adresse de fiche invalide.');
      }
      const ref = collection(db, family, recordId, 'aiHistory');
      return onSnapshot(query(ref, orderBy('at', 'desc'), limit(30)), (snapshot) => {
        onValue(snapshot.docs.filter((entry) => entry.data()['status'] === 'applied').map((entry) => {
          const data = entry.data();
          const timestamp = data['at'] as { toDate?: () => Date } | undefined;
          return {
            id: entry.id,
            at: typeof timestamp?.toDate === 'function' ? timestamp.toDate() : null,
            uid: typeof data['uid'] === 'string' ? data['uid'] : '',
            email: typeof data['email'] === 'string' ? data['email'] : null,
            source: iaHistorySource(data['source']),
            action: iaHistoryAction(data['action']),
            fields: Array.isArray(data['fields']) ? data['fields'].filter((field): field is string => typeof field === 'string') : [],
          };
        }));
      }, onError);
    },
  };
}
